export const BREAKPOINTS = {
  XXS: 400,
  XS: 560,
  S: 768,
  M: 1024,
  D: 1280,
  L: 1440,
  XL: 1680,
  XXL: 1920,
};